exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".layoutBox {\n  width: 100%;\n  height: 100%;\n  background: #0d1427; }\n  .layoutBox .layoutLower {\n    width: 100%;\n    background: #0d1427;\n    overflow: hidden; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/component/layout/index.scss
// module id = 629
// module chunks = 0